import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Settings from './pages/Settings';
import Dashboard from './pages/Dashboard';
import StrategySettings from './pages/StrategySettings';
import StrategyExecution from './pages/StrategyExecution';
import Backtest from './pages/Backtest';
import KrBacktest from './pages/KrBacktest';
import TradingHistory from './pages/TradingHistory';
import Reports from './pages/Reports';
import ReportDetail from './pages/ReportDetail';
import OperatingPerformance from './pages/OperatingPerformance';
import Operations from './pages/Operations';
import LossStructure from './pages/LossStructure';
import Checklist from './pages/Checklist';
import AnalystLearning from './pages/AnalystLearning';
import SystemOverview from './pages/SystemOverview';
import Atu2Lab from './pages/Atu2Lab';
import Atu2LabFable from './pages/Atu2LabFable';
import TradingModeBadge from './components/TradingModeBadge';
import SidebarNav from './components/SidebarNav';
import './App.css';
import { ApiStatus, getApiStatus } from './services/systemApi';
import { navItems } from './navigation';

const Home: React.FC = () => {
  const [apiStatus, setApiStatus] = useState<ApiStatus | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getApiStatus()
      .then(data => {
        setApiStatus(data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <div className="home">
      <h1>ATU2 MVP</h1>
      <p>자동매매 시스템</p>

      {loading && <p>로딩 중...</p>}
      {error && <p className="error">API 오류: {error}</p>}
      {apiStatus && (
        <div className="status">
          <p>{apiStatus.message}</p>
          <p>버전: {apiStatus.version}</p>
          <p>상태: {apiStatus.status}</p>
        </div>
      )}

      <div className="navigation">
        {navItems.map((item) => (
          <Link key={item.to} to={item.to} className="nav-link">
            {item.label}
          </Link>
        ))}
      </div>
    </div>
  );
};

function App() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <Router>
      <div className="App">
        <aside className={`app-sidebar${mobileNavOpen ? ' nav-open' : ''}`}>
          <div className="sidebar-head">
            <Link to="/" className="logo" onClick={() => setMobileNavOpen(false)}>
              <span className="logo-mark">A2</span>
              <span>
                <strong>ATU2</strong>
                <small>Auto Trading</small>
              </span>
            </Link>
            <button
              type="button"
              className="mobile-nav-toggle"
              aria-expanded={mobileNavOpen}
              onClick={() => setMobileNavOpen((open) => !open)}
            >
              {mobileNavOpen ? '메뉴 닫기' : '메뉴'}
            </button>
          </div>
          <SidebarNav onNavigate={() => setMobileNavOpen(false)} />
        </aside>
        <div className="app-shell">
          <header className="app-topbar">
            <div>
              <span className="eyebrow">자동매매 운영</span>
              <p>실제 데이터 기반 자동매매 운영 화면</p>
            </div>
            <TradingModeBadge className="topbar-status" />
          </header>
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/atu2-lab" element={<Atu2Lab />} />
              <Route path="/atu2-lab-fable" element={<Atu2LabFable />} />
              <Route path="/system-overview" element={<SystemOverview />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/operations" element={<Operations />} />
              <Route path="/analyst-learning" element={<AnalystLearning />} />
              <Route path="/loss-structure" element={<LossStructure />} />
              <Route path="/checklist" element={<Checklist />} />
              <Route path="/performance" element={<OperatingPerformance />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/strategy-settings" element={<StrategySettings />} />
              <Route path="/strategy-execution" element={<StrategyExecution />} />
              <Route path="/history" element={<TradingHistory />} />
              <Route path="/backtest" element={<Backtest />} />
              <Route path="/kr-backtest" element={<KrBacktest />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/reports/:date" element={<ReportDetail />} />
            </Routes>
          </main>
        </div>
      </div>
    </Router>
  );
}

export default App;
